import React from 'react';

const ScrollIndicators = ({ scrollProgress, showScrollFade }) => {
  return (
    <>
      {/* Scroll Progress Bar */}
      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: `${scrollProgress}%`,
        height: "3px",
        background: "linear-gradient(90deg, #4CAF50, #45a049)",
        transition: "width 0.1s ease-out",
        zIndex: 1000,
        boxShadow: "0 0 10px rgba(76, 175, 80, 0.5)"
      }} />
      
      {/* Scroll Fade Indicator */}
      {showScrollFade && (
        <div style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          height: "80px",
          background: "linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,0.95) 50%, rgba(255,255,255,1))",
          pointerEvents: "none",
          zIndex: 999,
          transition: "opacity 0.3s ease-in-out"
        }} />
      )}
    </>
  );
};

export default ScrollIndicators;
